var map = {
	"./about.svg": 2073,
	"./achievements.svg": 4770,
	"./certifications.svg": 2,
	"./contact.svg": 8085,
	"./github.svg": 3249,
	"./linkedin.svg": 4741,
	"./mail.svg": 6289,
	"./phone.svg": 1328,
	"./projects.svg": 7430,
	"./resume.svg": 3138,
	"./skills.svg": 1593,
	"./socials.svg": 1545,
	"./whatsapp.svg": 1068
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6516;